import React from 'react';

function OrnefnaskraDownloadLink(props) {
	let universalBOM = '\ufeff';


	let createCsv = (data) => {
		let csv = '';

		let addLine = (cells) => {
			csv += (() => cells.map((cell) => '"'+cell+'"').join(';')+'\r\n')();
		}

		let line;

		line = ['Örnefnaskrá:', data.titill];
		if (data.pdf && data.pdf.pdf_url) {
			line = line.concat(['Slóð á örnefnaskrá:', data.pdf.pdf_url]);
		}
		addLine(line);
		addLine(['Hreppur:', data.hreppur.nafn, 'Sýsla:', data.sysla.nafn]);


		if (data.baeir && data.baeir.length > 0) {
			addLine(['']);
			addLine(['Tengdir bæir:']);

			addLine(['Bæjarnafn', 'Sveitafélag', 'Hreppur', 'Sýsla']);
			data.baeir.forEach((baer, i) => {
				addLine([baer.baejarnafn, baer.sveitarfelag.nafn, baer.hreppur.nafn, baer.sysla.nafn]);
			});

		}

		if (data.einstaklingar && data.einstaklingar.length > 0) {
			addLine(['']);
			addLine(['Tengdir einstaklingar:']);

			addLine(['Nafn', 'Hlutverk']);
			data.einstaklingar.forEach((einstaklingur, i) => {
				addLine([einstaklingur.einstaklingur.nafn, einstaklingur.hlutverk ? einstaklingur.hlutverk.hlutverk : ''])
			});

		}

		if (data.ornefni && data.ornefni.length > 0) {
			addLine(['']);
			addLine(['Örnefni:']);

			data.ornefni.forEach((ornefni, i) => {
				addLine([ornefni.ornefni, ornefni.lat || '', ornefni.lon || ''])
			});

		}

		return csv;
	}

	let clickHandler = (event) => {
		event.preventDefault();

		if (props.data) {
			let csv = createCsv(props.data);

			var downloadLink = document.createElement('a');
			downloadLink.setAttribute('href', 'data:application/octet-stream;charset=UTF-8,'+universalBOM+encodeURIComponent(csv));
			downloadLink.setAttribute('download', props.data.titill+'.csv');

			document.body.appendChild(downloadLink);

			downloadLink.click();

			downloadLink.remove();
		}
	}
	return <span className={'tool-button download-button '+(props.className || '')}>
		<button alt={props.label || 'Hlaða niður'} title={props.label || 'Hlaða niður'} onClick={clickHandler} />
	</span>
}

export default OrnefnaskraDownloadLink;



// WEBPACK FOOTER //
// ./src/components/OrnefnaskraDownloadLink.js